import { useGlobalContext } from "@/context/GlobalProvider";

export const useSearch = () => {
  const { searchDisplayedSuggestion, setSearchDisplayedSuggestion } =
    useGlobalContext();

  return {
    searchDisplayedSuggestion,
    setSearchDisplayedSuggestion,
  };
};
